import React from "react";

import {LeadModel} from "@/typings/models/Lead";
import PrettyDate from "@/components/PrettyDate";

import styles from "./index.less"
import {F, INTL_ATTRIBUTE, INTL_ENTITY} from "@/utils/intl";

const LeadCustomerModifiedAt = ({lead, isTable}: {lead: LeadModel, isTable?: boolean}) => {
  if (!lead?.customer?.modified) return <div> - </div>
  const content = <PrettyDate date={lead.customer.modified} />

  if (isTable) return content

  return <div>
    <div className={styles.tinyDateKey}><F entity={INTL_ENTITY.CUSTOMER} attribute={INTL_ATTRIBUTE.UPDATED_AT}/></div>
    <div>{content}</div>
  </div>

}

export default LeadCustomerModifiedAt
